<div class="ui-tooltip" [ngClass]="tooltipClassInput()" role="tooltip">
  <span class="ui-tooltip__text">{{ messageInput() }}</span>
  <span class="ui-tooltip__arrow"></span>
</div>
